(function () {
  'use strict';

  var config = window.athBuyMoreConfig || {};
  var regularRates = config.regularRates || [0, 5, 10, 15, 20];
  var deadline = Date.parse(config.endsAt);

  function tier(count) {
    return Math.max(1, Math.min(5, Math.floor(Number(count) || 0)));
  }

  function isActive() {
    return config.enabled === true && isFinite(deadline) && Date.now() < deadline;
  }

  function regularPercent(count) {
    return Number(regularRates[tier(count) - 1]) || 0;
  }

  function percent(count) {
    return regularPercent(count) + (tier(count) > 1 && isActive() ? Number(config.bonus) || 0 : 0);
  }

  function coupon(count) {
    if (Number(count) < 2) return null;
    return 'BUYMORE' + tier(count) + (isActive() ? config.couponSuffix : '');
  }

  function total(cents, count) {
    return Math.round(cents * (100 - percent(count)) / 100);
  }

  function badge(count, regularLabel) {
    if (count < 2) return '';
    if (!isActive()) return regularLabel || (regularPercent(count) + '% OFF');
    return '<s class="buy-more-discount__original">' + regularPercent(count) + '% OFF</s>' +
      '<strong class="buy-more-discount__bonus">' + percent(count) + '% OFF</strong>';
  }

  function message(count, totalPrice) {
    if (!count) return '';
    var applied = count > 1 ? '<strong>' + percent(count) + '% OFF APPLIED!</strong>' : '';
    if (count >= 5) {
      return applied + (totalPrice >= 9900 ? ' YOUR ORDER SHIPS FREE, LOAD UP!' : '');
    }
    return (applied ? applied + ' ' : '') + 'ADD 1 MORE TO GET <strong>' +
      percent(count + 1) + '% OFF!</strong>';
  }

  var wasActive = isActive();
  function refresh() {
    var active = isActive();
    document.querySelectorAll('[data-ebf-ends-at]').forEach(function (banner) {
      banner.hidden = !active;
      if (!active) return;
      var seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      var days = Math.floor(seconds / 86400);
      var hours = Math.floor(seconds % 86400 / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      function pad(value) { return value < 10 ? '0' + value : '' + value; }
      var clock = banner.querySelector('[data-ebf-clock]');
      if (clock) clock.textContent = 'Ends in ' + days + 'd ' + pad(hours) + 'h ' +
        pad(minutes) + 'm ' + pad(seconds % 60) + 's';
    });
    document.querySelectorAll('[data-buy-more-title]').forEach(function (label) {
      label.textContent = active ? 'EBF BONUS!' : 'Level Up!';
    });
    document.querySelectorAll('[data-buy-more-percent]').forEach(function (label) {
      label.textContent = percent(Number(label.getAttribute('data-buy-more-percent'))) + '% Off';
    });
    document.querySelectorAll('[data-buy-more-bonus-heading]').forEach(function (heading) {
      heading.hidden = !active;
    });
    document.querySelectorAll('[data-bundle-tier]').forEach(function (card) {
      var count = Number(card.getAttribute('data-bundle-tier'));
      var callout = card.querySelector('.discount-tier__callout');
      var regularLabel = count === 5 ? 'FREE BAG' : regularPercent(count) + '% OFF';
      var html = badge(count, regularLabel);
      if (callout && callout.innerHTML !== html) callout.innerHTML = html;
      var perStick = card.querySelector('.discount-tier__per-stick');
      var referencePrice = Number(card.getAttribute('data-reference-price'));
      if (perStick && referencePrice) {
        var text = '$' + (total(referencePrice * count, count) / (count * 30 * 100)).toFixed(2) + ' / stick';
        if (perStick.textContent !== text) perStick.textContent = text;
      }
      if (card.parentNode) card.parentNode.classList.toggle('tiered-discount-info--ebf', active);
    });
    if (wasActive !== active) {
      wasActive = active;
      document.dispatchEvent(new CustomEvent('ath:buy-more-change'));
    }
  }

  window.athBuyMore = { isActive: isActive, regularPercent: regularPercent, percent: percent, coupon: coupon,
    total: total, badge: badge, message: message, refresh: refresh };

  function init() {
    refresh();
    setInterval(refresh, 1000);
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('shopify:section:load', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
